export function DropdownInputPlugin(options) {
  const tomSelect = this
  tomSelect.settings.shouldOpen = true

  tomSelect.hook("before", "setup", () => {
    tomSelect.focus_node = tomSelect.control

    const div = document.createElement("div")
    div.classList.add("dropdown-input-wrap")

    tomSelect.control_input.setAttribute("placeholder", options.placeholder)

    div.append(tomSelect.control_input)

    tomSelect.dropdown.insertBefore(div, tomSelect.dropdown.firstChild)

    tomSelect.control_input.addEventListener("blur", (e) => tomSelect.onBlur(e))
  })

  tomSelect.hook("before", "close", () => {
    if( !tomSelect.isOpen ) {
      return
    }

    tomSelect.focus_node.focus({ preventScroll: true })
  })

  const originalOnBlur = tomSelect.onBlur
  tomSelect.hook("instead", "onBlur", (e) => {
    if (e && e.relatedTarget == tomSelect.control_input) {
      return
    }

    return originalOnBlur.call(tomSelect)
  })

  tomSelect.on("initialize", () => {
    tomSelect.control_input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if (tomSelect.isOpen) {
          e.preventDefault()
          tomSelect.close()
        }

        tomSelect.clearActiveItems()
        return
      }

      tomSelect.onKeyDown.call(tomSelect, e)
    })
  })
}
